import React, { Component } from "react";

import {Row, Col, Upload } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
// import { useSelector, useDispatch } from "react-redux";
import { getBase64, beforeUpload } from "./AvatarMessages";
// import { Col } from "reactstrap";



class Avatar extends Component {
  state = {
    loading: false,
  };

  handleChange = (info) => {
    if (info.file.status === "uploading") {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) =>
        this.setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  render() {
    const uploadButton = (
      <div>
        {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
        {//<div className="ant-upload-text">انتخاب لوگو</div>
        }
      </div>
    );
    const { imageUrl } = this.state;
    return (
      <Row>
        
        <Col span={24}>
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            beforeUpload={beforeUpload}
            onChange={this.handleChange}
          >
            {imageUrl ? (
              <img className="avatar-users" src={imageUrl} alt="avatar" style={{ width: "100%" }} />
            ) : (
              uploadButton
            )}
            
          </Upload>
        </Col>
      </Row>
    );
  }
}

export default Avatar;
